type InviteMembersError = {
  invalidEmail: boolean;
  invalidLastName: boolean;
  invalidFirstName: boolean;
  emptyRole: boolean;
  duplicatedInvitation: boolean;
};

const inviteMembersError: InviteMembersError = {
  invalidEmail: false,
  invalidFirstName: false,
  invalidLastName: false,
  emptyRole: false,
  duplicatedInvitation: false,
};

export type { InviteMembersError };

export { inviteMembersError };
